import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'ifNotNull'
})
export class IfNotNullPipe implements PipeTransform {

    transform<T>(value: T[], field: string): T[] {
        return value?.filter(v => !!v[field]);
    }

}
